import { useLayoutEffect, useRef, useCallback } from "react";

const useCalcSettlementCalendarDayWidth = () => {
  const calendarWrapperRef = useRef<HTMLDivElement>(null);

  const syncDayCellWidth = useCallback(() => {
    const wrapper = calendarWrapperRef.current;
    if (!wrapper) return;

    requestAnimationFrame(() => {
      const dayCell = wrapper.querySelector<HTMLElement>(".fc-daygrid-day");
      if (!dayCell) return;

      const { width } = dayCell.getBoundingClientRect();

      wrapper.style.setProperty("--day-cell-width", `${width}px`);
    });
  }, []);

  useLayoutEffect(() => {
    const wrapper = calendarWrapperRef.current;
    if (!wrapper) return;

    syncDayCellWidth();

    const resizeObserver = new ResizeObserver(() => {
      syncDayCellWidth();
    });

    resizeObserver.observe(wrapper);

    return () => {
      resizeObserver.disconnect();
    };
  }, [syncDayCellWidth]);

  return { calendarWrapperRef, syncDayCellWidth };
};

export default useCalcSettlementCalendarDayWidth;
